import React from "react";

const TimerPickerCustom = ({ value, onChange }) => {
  const [hour = "00", minute = "00"] = value?.split(":") || [];

  const hours = Array.from({ length: 24 }, (_, i) =>
    String(i).padStart(2, "0")
  );
  const minutes = Array.from({ length: 60 }, (_, i) =>
    String(i).padStart(2, "0")
  );

  const handleHourChange = (newHour) => {
    onChange(`${newHour}:${minute}`);
  };

  const handleMinuteChange = (newMinute) => {
    onChange(`${hour}:${newMinute}`);
  };

  const containerStyle = {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    padding: "8px",
    border: "1px solid #d9d9d9",
    borderRadius: "6px",
    width: "fit-content",
    backgroundColor: "#fff",
    boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
  };

  const selectStyle = {
    padding: "6px 12px",
    fontSize: "14px",
    borderRadius: "4px",
    border: "1px solid #ccc",
    outline: "none",
    cursor: "pointer",
    appearance: "none",
    backgroundColor: "#f9f9f9",
  };

  const separatorStyle = {
    fontWeight: "bold",
    fontSize: "16px",
  };

  return (
    <div style={containerStyle}>
      <select
        value={hour}
        onChange={(e) => handleHourChange(e.target.value)}
        style={selectStyle}
      >
        {hours.map((h) => (
          <option key={h} value={h}>
            {h}
          </option>
        ))}
      </select>
      <span style={separatorStyle}>:</span>
      <select
        value={minute}
        onChange={(e) => handleMinuteChange(e.target.value)}
        style={selectStyle}
      >
        {minutes.map((m) => (
          <option key={m} value={m}>
            {m}
          </option>
        ))}
      </select>
    </div>
  );
};

export default TimerPickerCustom;
